import React from "react";
import { formatDateFull } from "../../utils/helper";

export const RequestNotification = ({ item }) => {
  const [assignedBy, title, start_date, due_date] = item.description.split("|");
  return (
    <div sx={{ fontSize: 12, marginTop: "5px" }}>
      <div className={"row"} spacing={1}>
        <div className={"col-sm-12"}>
          <b>New Request</b>
        </div>
        <div className={"col-sm-4"}>Start Date</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{start_date}</div>

        <div className={"col-sm-4"}>Due Date</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{due_date}</div>

        <div className={"col-sm-4"}>Assigned by</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{assignedBy}</div>

        <div className={"col-sm-4"}>Title</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{title}</div>
      </div>
    </div>
  );
};
